import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#06122A] border-t border-[#B89968]/15 py-16 md:py-20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid md:grid-cols-12 gap-10 mb-12">
          <div className="md:col-span-5">
            <img
              src="https://customer-assets.emergentagent.com/job_newman-justice-fund/artifacts/a662viyt_Newman%20Injury%20Law.png"
              alt="Newman Injury Law"
              loading="lazy"
              decoding="async"
              className="h-14 md:h-16 w-auto mb-5"
              style={{ filter: "brightness(0) invert(1)" }}
            />
            <p className="text-[#94A3B8] leading-relaxed max-w-md">
              Personal, dedicated representation for the injured across Florida
              and Texas. Millions recovered. Available 24/7 for a free, no-obligation
              consultation.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.28em] text-[#B89968] mb-4">
              Practice Areas
            </div>
            <ul className="space-y-2 text-[#CBD5E1]">
              <li>Auto Accidents</li>
              <li>Truck Accidents</li>
              <li>Motorcycle Accidents</li>
              <li>Premises Liability</li>
              <li>Wrongful Death</li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.28em] text-[#B89968] mb-4">
              Get In Touch
            </div>
            <p className="text-[#CBD5E1] leading-relaxed mb-4">
              Serving Florida & Texas
              <br />
              Available 24/7 for a free consultation.
            </p>
            <a
              href="#lead-form"
              onClick={(e) => {
                e.preventDefault();
                document
                  .getElementById("lead-form")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
              data-testid="footer-cta"
              className="inline-flex items-center gap-2 text-[#B89968] hover:text-[#CFB079] uppercase tracking-[0.22em] text-xs transition-colors"
            >
              Request Free Consultation →
            </a>
          </div>
        </div>

        <div className="pt-8 border-t border-[#B89968]/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-[#64748B]">
          <div>© {year} Newman Injury Law, PLLC. All rights reserved.</div>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <Link
              to="/privacy"
              data-testid="footer-privacy-link"
              className="hover:text-[#B89968] transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              data-testid="footer-terms-link"
              className="hover:text-[#B89968] transition-colors"
            >
              Terms of Service
            </Link>
            <Link
              to="/terms"
              data-testid="footer-disclaimer-link"
              className="hover:text-[#B89968] transition-colors"
            >
              Disclaimer
            </Link>
          </div>
        </div>

        <p className="mt-6 text-[11px] text-[#64748B] leading-relaxed max-w-4xl">
          The information on this website is for general information purposes
          only. Nothing on this site should be taken as legal advice for any
          individual case or situation. This information is not intended to
          create, and receipt or viewing does not constitute, an attorney-client
          relationship. Past results do not guarantee future outcomes.
        </p>
      </div>
    </footer>
  );
}
